import React from 'react'
import { useTranslation } from '../../../../i18n'
import { StepWizardChildProps } from 'react-step-wizard'
import { isMobile } from 'react-device-detect'

import XCard from '../../xCard'
import XBack from '../../../components/XBack'

import styles from './style.module.scss'
import XText from 'v2/components/XText'
import { XTEXT_DECORATIONS, XTEXT_MARGINS, XTEXT_SIZE } from 'v2/styles/constants'
import XColors from 'v2/styles/colors'

interface Props {
    onBack: () => void
}

const HelpContactUs: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const { t } = useTranslation(window.LANG_NS)

    return (
        <div id="helpContactUs" className={styles.helpContactUs}>
            {!isMobile && <XBack onClick={props.onBack} />}
            <XCard
                backButton={isMobile ? t('back') : null}
                backButtonAction={isMobile ? props.onBack : null}
                title={t('contact_us')}
                bottomContent={
                    <>
                        <div className={styles.helpContactUs__phone_number}>
                            <XText
                                size={XTEXT_SIZE.LARGE}
                                color={XColors.primaryColor}
                                decorator={XTEXT_DECORATIONS.REGULAR}
                                margins={XTEXT_MARGINS.NO_MARGINS}
                            >
                                {window.ORGANIZATION_CONFIGS.phoneNumber}
                            </XText>
                        </div>
                        <div className={styles.helpContactUs__description}>
                            <XText
                                size={XTEXT_SIZE.SMALL}
                                color={XColors.textColor}
                                decorator={XTEXT_DECORATIONS.REGULAR}
                                margins={XTEXT_MARGINS.NO_MARGINS}
                            >
                                {t('contact_description')}
                            </XText>
                        </div>
                    </>
                }
            />
        </div>
    )
}

export default HelpContactUs
